module.exports = __webpack_public_path__ + "media/images/dumbbell-1490cc4c5f9adf0fcbc379a8e2999425.png";